<template>
   <article :class="['box panelback relative p-4 w-full h-[380px] flex flex-wrap place-items-start', {'cancelled': show.status == 'cancelled'}]" itemscope itemtype="https://schema.org/ComedyEvent">
        <div class="w-full flex flex-wrap justify-between">
            <img v-if="show.image" class="w-1/2 max-h-[220px] object-cover overflow-hidden float-left border border-slate-600/40" :src="`/show-image/${show.image.replace('.','/')}/300`" :alt="show.show" fetchpriority="high" />
            <div v-if="show.status=='cancelled' || show.status=='woodout'" class="bg-black/40 absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 text-6xl -rotate-[25deg] text-center pb-2">
                <span v-if="show.status=='cancelled'">
                    Cancelled
                </span>
                <span v-if="show.status=='woodout'">
                    Show's On I can't make it
                </span>
            </div>
            <div class="w-1/2 flex flex-col justify-between p-2 pl-4 pb-0 text-slate-300">
                <div>
                    <div class="w-full pb-1 secondary-medium" itemprop="startDate" :content="formatDate(show.date)">
                    {{  formatDate(show.date, 'ddd MMM DD, YYYY') }} {{ show.time }}
                </div>
                    <h2 class="text-2xl pb-2 text-secondary-light font-display font-normal leading-6 " itemprop="name">{{ show.show }}</h2>
                    <p class="leading-2 text-xl text-green-100">{{ printDescription(show.description) }}</p>
                </div>
                <div v-if="show.performers">With {{ performerList(show.performers) }}</div>
                <div>
                    <div v-if="show.venue_url" itemprop="location" itemscope itemtype="https://schema.org/Place">
                        <a :href="show.venue_url" class="text-secondary-light" itemprop="url"><span itemprop="name">{{ show.venue }}</span></a>, <span itemprop="address" itemscope itemtype="https://schema.org/PostalAddress"><br><span itemprop="addressLocality">{{ address(show.location, 0) }}</span>, <span itemprop="addressRegion">{{ address(show.location, 1) }}</span></span>
                    </div>
                    <template v-if="show.show_url && show.description.indexOf('Private') == -1">
                        <a :href="show.show_url" ><button class="w-full uppercase text-lg text-white button  rounded p-2 pt-1 pb-1">
                            &#127915;&nbsp;
                            {{ printLinkButton(show) }}
                        </button></a>
                    </template>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import dayjs from 'dayjs'
export default {
    name: "ShowObject",
    props: ['show'],
    computed: {},
    data() {
       return {

       }
    },
    mounted() {

    },
    methods: {
        address(location, half=0) {

            return location.split(', ')[half];
        },
        formatDate(a, b) {
            const date=dayjs(a);
            return date.format(b);
        },
        formatISO(d) {
            return DFunk.formatISO(DFunk.parseISO(d));
        },
        printLinkButton(show) {
            if(show.status == 'cancelled') {
                return 'Cancelled';
            }
            let s=show.show_url;
            switch (true) {
                case s.indexOf("twitch") > -1:
                case s.indexOf("zoom") > -1:
                case s.indexOf("facebook") > -1:
                    return 'Link';
                case s.indexOf('twitch') > -1:
                    return 'Twitch link';
                case s.indexOf("vermontcomedyclub") > -1:
                    return "Tickets";
                case s.indexOf('highlight') > -1:
                    return 'Highlight Tickets'
            }

            return
        },
        performerList(performers) {
                const performerArray = [];
                performers.forEach(p => {
                    performerArray.push(`${p.firstname} ${p.lastname}`);
                })
                return new Intl.ListFormat().format(performerArray);
        },
        printDescription(d) {
            if(this.$page.url == '/') {
                return d.substring(0,120) + "... ";
            }
            return d;
        }
    }
}
</script>
<style lang="postcss">
.xshow {
    box-shadow: -2px -2px 4px rgba(0,0,0,.07), 2px 2px 8px rgba(0,0,0,.1);
}
</style>
